export default __webpack_public_path__ + "static/media/benefits.b6902e30.png";